import React from 'react';
// Components:
import AgreeBlock from '../../../../../components/Payment/AgreeBlock';
import Agreement from './Agreement';

import HotelAgreement from './HotelAgreement';

type AgreeBlockContainerProps = {
  isWhitelabel: boolean;
  isMobile: boolean;
  isHotelOnly: boolean;
  className?: string;
  isIncludedAgreementProvisionAdditionalServices?: boolean;
};
export const AgreeBlockContainer = ({
  isWhitelabel,
  isMobile,
  isHotelOnly,
  className,
  isIncludedAgreementProvisionAdditionalServices = false,
}: AgreeBlockContainerProps) => (
  <AgreeBlock className={className}>
    {isHotelOnly ? (
      <HotelAgreement
        isMobile={isMobile}
        isWhitelabel={isWhitelabel}
        isHotelOnly={isHotelOnly}
      />
    ) : (
      <Agreement
        isMobile={isMobile}
        isWhitelabel={isWhitelabel}
        isIncludedAgreementProvisionAdditionalServices={
          isIncludedAgreementProvisionAdditionalServices
        }
      />
    )}
  </AgreeBlock>
);
